/** Лимиты Discord API (актуально для API v10, 2025-2026). */
export const LIMITS = {
  content: 2000,
  embedsPerMessage: 10,
  embedTotal: 6000,
  embedTitle: 256,
  embedDescription: 4096,
  embedFields: 25,
  fieldName: 256,
  fieldValue: 1024,
  footerText: 2048,
  authorName: 256,
  url: 2048,

  actionRows: 5,
  buttonsPerRow: 5,
  buttonLabel: 80,
  customId: 100,
  linkUrl: 512,
  selectOptions: 25,
  selectPlaceholder: 150,
  optionLabel: 100,
  optionValue: 100,
  optionDescription: 100,

  pollQuestion: 300,
  pollAnswers: 10,
  pollAnswerText: 55,
  pollMaxHours: 768,

  attachments: 10,
  attachmentDescription: 1024,
  fileSizeBytes: 10 * 1024 * 1024,

  v2Components: 40,
  v2TextTotal: 4000,
  v2TopLevel: 10,
  containerChildren: 10,
  sectionTexts: 3,
  galleryItems: 10,
  mediaDescription: 1024,

  webhookUsername: 80,
  templateName: 100,
} as const;

/** Имена, которые Discord запрещает для вебхуков. */
export const FORBIDDEN_WEBHOOK_NAMES = ['clyde', 'discord'];
